<script setup>
import {ref} from "vue";
import AiChatModal from "@/components/aiChat/AiChatModal.vue";

const exampleQuestions = [
    'How many startups did we interact with last year?',
    'If we have met before, please provide notes related to <CompanyName>',
    'Who are all the companies we engaged with in last year?',
    'How many new companies did we engage with over the past 6 moths by month?'
];

const chatModal = ref(null);
const question = ref('');
const questionInput = ref(null);

function openModal() {
    if (!question.value.trim()) {
        return;
    }

    chatModal.value.open(question);
}

function populateQuestion(exampleQuestionNumber) {
    question.value = exampleQuestions[exampleQuestionNumber];
    questionInput.value.focus();
}
</script>

<template>
    <div class="card card--bordered card--ai">
        <h5 class="heading5 heading5--secondary">What do you want to know?</h5>

        <div class="card--ai__search">
            <input
                ref="questionInput"
                v-model="question"
                placeholder="Ask about startups or partnerships"
                class="card--ai__search__input"
                @keyup.enter="openModal"
            >

            <button class="card--ai__search__button" @click="openModal(true)"></button>
        </div>

        <ul class="card--ai__list">
            <li class="card--ai__list__startup pointer" @click="populateQuestion(0)">{{exampleQuestions[0]}}</li>
            <li class="card--ai__list__ecosystem pointer" @click="populateQuestion(1)">{{exampleQuestions[1]}}</li>
            <li class="card--ai__list__partner pointer" @click="populateQuestion(2)">{{exampleQuestions[2]}}</li>
            <li class="card--ai__list__intelligence pointer" @click="populateQuestion(3)">{{exampleQuestions[3]}}</li>
        </ul>

        <!-- AI Chat -->
        <!-- <a class="link" @click="openModal">Open Modal</a> -->

        <AiChatModal
            ref="chatModal"
        />
    </div>
</template>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>
